<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" />
      </v-card-title>
      <v-card-text style="color: #4F4F4F">
        <v-container class="pa-0 text-left">
          <div v-if="isSubscribed" style="text-align: start" class="pb-3">
            Congratulations! Your Self-service Certificates configuration is complete.
            <br />Please restart CMS to begin using this product.
          </div>
          <div v-else style="text-align: start" class="pb-3">
            Your Self-service Certificates Subscription has been cancelled.
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <div class="pa-1">
          <v-btn @click="returnToMarketplace()">Return to Marketplace</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';

export default {
  name: 'SelfServeCertsSuccess',
  components: {
    ProductCardHeader
  },
  computed: {
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(7);
    },
    isSubscribed () {
      var product = this.getProductByProductId(7);
      if (product) {
        return product.isSubscribed;
      }
      return false;
    }
  },
  methods: {
    returnToMarketplace () {
      this.$router.push('/marketplace');
    }
  }
};

</script>
